/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ limit: NonNullable<unknown> }} Settings_Ai_Actions_RemainingInputs */

const en_settings_ai_actions_remaining = /** @type {(inputs: Settings_Ai_Actions_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`/ ${i?.limit} AI actions remaining`)
};

const de_settings_ai_actions_remaining = /** @type {(inputs: Settings_Ai_Actions_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`/ ${i?.limit} KI-Aktionen übrig`)
};

const fr_settings_ai_actions_remaining = /** @type {(inputs: Settings_Ai_Actions_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`/ ${i?.limit} actions IA restantes`)
};

const es_settings_ai_actions_remaining = /** @type {(inputs: Settings_Ai_Actions_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`/ ${i?.limit} Acciones IA restantes`)
};

const it_settings_ai_actions_remaining = /** @type {(inputs: Settings_Ai_Actions_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`/ ${i?.limit} azioni AI rimanenti`)
};

const nl_settings_ai_actions_remaining = /** @type {(inputs: Settings_Ai_Actions_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`/ ${i?.limit} AI-acties over`)
};

const pl_settings_ai_actions_remaining = /** @type {(inputs: Settings_Ai_Actions_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`/ ${i?.limit} akcji AI pozostało`)
};

const fi_settings_ai_actions_remaining = /** @type {(inputs: Settings_Ai_Actions_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`/ ${i?.limit} AI-toimet jäljellä`)
};

const da_settings_ai_actions_remaining = /** @type {(inputs: Settings_Ai_Actions_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`/ ${i?.limit} AI-handlinger tilbage`)
};

const sv_settings_ai_actions_remaining = /** @type {(inputs: Settings_Ai_Actions_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`/ ${i?.limit} AI-aktioner kvar`)
};

/**
* | output |
* | --- |
* | "/ {limit} AI actions remaining" |
*
* @param {Settings_Ai_Actions_RemainingInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const settings_ai_actions_remaining = /** @type {((inputs: Settings_Ai_Actions_RemainingInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Ai_Actions_RemainingInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_settings_ai_actions_remaining(inputs)
	if (locale === "fr") return fr_settings_ai_actions_remaining(inputs)
	if (locale === "es") return es_settings_ai_actions_remaining(inputs)
	if (locale === "it") return it_settings_ai_actions_remaining(inputs)
	if (locale === "nl") return nl_settings_ai_actions_remaining(inputs)
	if (locale === "pl") return pl_settings_ai_actions_remaining(inputs)
	if (locale === "fi") return fi_settings_ai_actions_remaining(inputs)
	if (locale === "da") return da_settings_ai_actions_remaining(inputs)
	if (locale === "sv") return sv_settings_ai_actions_remaining(inputs)
	return en_settings_ai_actions_remaining(inputs)
});